export const regularWidth = 180;
export const mobileWidth = 130;
export const regularHeight = 50;
export const mobileHeight = 50;
export const miniWidth = 33;
export const miniHeight = 20;
